"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_BENEFIT_PERCENT = void 0;
exports.REFERRAL_BENEFIT_PERCENT = 15;
